exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3lycr9qGPoUYgCGG8CLw51 {\n}\n._3rnDd8Rf7gvtElYTEWMYH1 {\n  width: 600px;\n  -webkit-transform: scale(.6, .6);\n      -ms-transform: scale(.6, .6);\n          transform: scale(.6, .6);\n  -webkit-transform-origin: 0 0;\n      -ms-transform-origin: 0 0;\n          transform-origin: 0 0;\n  background-color: #fff;\n}\n._3dXZHybBifTR4wN1p3aBx8 {\n  -webkit-transform: scale(.6, .6) translate(0, -17px);\n      -ms-transform: scale(.6, .6) translate(0, -17px);\n          transform: scale(.6, .6) translate(0, -17px);\n}\n._3N2nu1CvJQSh3IIf6OcuVY{\n  font-size: 15px;\n  font-weight:600;\n  color: #000;\n  fill: #000;\n  font-family: 'Soleil', 'Helvetica Neue', helvetica, arial, sans-serif;\n}", ""]);

// exports
exports.locals = {
	"eKGPreview": "_3lycr9qGPoUYgCGG8CLw51",
	"previewGridNoTranslate": "_3rnDd8Rf7gvtElYTEWMYH1",
	"previewGrid": "_3dXZHybBifTR4wN1p3aBx8 _3rnDd8Rf7gvtElYTEWMYH1",
	"LeadTitle": "_3N2nu1CvJQSh3IIf6OcuVY"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/FullECGPreview/FullWidthECGPreview.css
// module id = 9551
// module chunks = 23